import React from "react";
import "./styles.css";
import Header from "./Header";
import Map from "./Map";

export default function MapHome() {

  return (
    <div className="App map-home-theme relative">
       <div className="svg-gradient-top svg-gradient-top-left"></div>
      <div>
     
     <div className="map-home-header-container">
      <div className="map-home-header">
          <h3 className="">ept RADIO</h3>
          <p className="">
            ept radio is a series of one-hour mixes curated by artists and creatives worldwide.
          </p>

        </div>
        </div>
      <Map 
        theme="blue"
        showTooltips={false}
      />
      </div>
    </div>
  );
}
